// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/SuperInvestor/index.css
// module id = 2573
// module chunks = 0